import { useState, useEffect } from 'react';
import TranslationText from '@Components/Utilities/TranslationText';
import translator from '@Components/Utilities/Translator';
import { bidderStatus } from '@Components/Utilities/SandhillsConstants';
import Button from '@mui/material/Button';
import Modal from '@Components/Shared/Modals/Modal';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';

const BidderStatusMessage = (props) => {

    const currentSite = useRecoilValue(atoms.currentWebsite);
    const [ssoHref, setSsoHref] = useState();
    const routes = useRecoilValue(atoms.routes);

    useEffect(() => {
        setSsoHref(`${routes.SSO}?to=${window.location.href}`)
    }, []);

    const getBidderStatusText = () => {
        if (props.showFullMessage) {
            switch (props.BidderStatus) {
                case bidderStatus.ACTIVE:
                    return (
                        <p><span>{props.CurrentUser_FirstName}</span>&nbsp;<TranslationText tKey='sandhills.tradepubwebsite.mvc.approvedstatustext' /></p>
                    );
                case bidderStatus.REVOKED:
                    return (
                        <>
                            <p><strong>{props.CurrentUser_FirstName},</strong>&nbsp;<strong>{translator.translate('sandhills.tradepubwebsite.mvc.revokedstatustext')}</strong></p>
                            <p><TranslationText tKey='sandhills.tradepubwebsite.mvc.speaktoarepresentative' /></p>
                        </>);
                default:
                    return (
                        <>
                            <p><strong>{props.CurrentUser_FirstName},</strong>&nbsp;<strong>{translator.translate('sandhills.incompleteregistration')}</strong></p>
                            <Button className="template-branded-button" variant="contained" href={routes.BidderRegistration}>
                                {translator.translate('sandhills.continueregistration')}
                            </Button>
                        </>);
            }
        }
    };

    const onClose = () => {
        props.toggleBidderStatusModal();
    };

    const showQuestionsText = () => {
        return !props.BidderStatus || ![bidderStatus.DISCARD, bidderStatus.REVOKED].includes(props.BidderStatus);
    };

    const getMessageContent = () => {
        return (
            <div className='bidder-status-more-info'>
                {getBidderStatusText()}

                {!props.excludeContactInfo &&
                    <>
                        {(!props.isModal && showQuestionsText()) &&
                            <p>{translator.translate('sandhills.tradepubwebsite.mvc.questions?')}</p>}
                        <p>{translator.translate('sandhills.tradepubwebsite.mvc.numberforreporsupporttext', [props.PhoneNumber])}</p>
                        <p><TranslationText tKey='sandhills.tradepubwebsite.mvc.officehours' /></p>
                    </>}
            </div>
        );
    }

    return (
        <>
            {props.isModal ?
                <Modal containerClassName='bidder-status-modal' onEscapeKeyClose={onClose}>
                    <Modal.Header onClose={onClose}>
                        <Modal.Title>
                            <>
                                {showQuestionsText() && translator.translate('sandhills.tradepubwebsite.mvc.questions?')}
                            </>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {getMessageContent()}
                    </Modal.Body>
                </Modal>
                :
                <>
                    {getMessageContent()}
                </>
            }
        </>
    );
};

export default BidderStatusMessage;